import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { RejectApprovalFlowActivity } from './activities/RejectApprovalFlow'

export default {
  sidebar: {
    items: [],
  },
  activities: {
    rejectApprovalFlow: {
      component: RejectApprovalFlowActivity,
    },
  },
} as const satisfies DomainManifest
